const RatingEnum = Object.freeze({
  1: 'ONE_STAR',
  2: 'TWO_STARS',
  3: 'THREE_STARS',
  4: 'FOUR_STARS',
  5: 'FIVE_STARS',
});

export default RatingEnum;
